module.exports = __webpack_public_path__ + "static/media/lukas-carey-logo.ea89ce1e.png";